import { Request } from "./HttpService";
import { translateAndSortAscendant } from "../common/helper";

export const jobRoleService = {
  getRoles: function () {
    return Request("vitae/jobrole", "GET").then((data)=>{
      return translateAndSortAscendant (data, "description");
    });
  }
};
